var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
  'app-loading' : _vm.$store.state.loadingCount > 0,
  'sm-up' : _vm.$vuetify.breakpoint.smAndUp,
  'sm-down' : _vm.$vuetify.breakpoint.smAndDown,
  'md-up' : _vm.$vuetify.breakpoint.mdAndUp,
  'md-down' : _vm.$vuetify.breakpoint.mdAndDown,
  'lg-up' : _vm.$vuetify.breakpoint.lgAndUp,
  'lg-down' : _vm.$vuetify.breakpoint.lgAndDown,
  'xl-only' : _vm.$vuetify.breakpoint.xlOnly,
  }},[_c('v-main',[_c('router-view')],1),_c('img',{staticClass:"virtual-cursor",attrs:{"id":"virtual-cursor","src":_vm.$asset('image/spinner.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }